/* ============================================
   BBC MOTION ENHANCE — Motion.dev + UI/UX Pro Max principles
   Chargé en defer après bbc-experience.js.

   Principes appliqués (ui-ux-pro-max SKILL §7) :
   - spring-physics : courbes ressort pour entrée/sortie naturelles
   - stagger-sequence : 35ms entre chaque item de liste/grille
   - scale-feedback : scale 0.97 au press sur cards/boutons
   - exit-faster-than-enter : sortie à 65 % de la durée d'entrée
   - transform-performance : transform/opacity seulement (jamais width/height)
   - duration-timing : 150–300ms micro, ≤ 400ms transitions
   - easing : ease-out pour l'entrée, ease-in pour la sortie
   - motion-meaning : chaque animation exprime une cause-effet
   - reduced-motion : tout désactivé si prefers-reduced-motion
   ============================================ */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var CDN = 'https://cdn.jsdelivr.net/npm/motion@latest/+esm';

  /* === Motion.dev chargé en ESM dynamique === */
  try {
    import(CDN).then(function (M) {
      var animate = M.animate;
      var scroll  = M.scroll;
      var stagger = M.stagger;
      if (typeof animate !== 'function') return;

      initScrollReveals(animate, stagger);
      initCardHover(animate);
      initButtonPress(animate);
      initTransparencyBars(animate, stagger);
      initTestimonialsStagger(animate, stagger);

    }).catch(function () { /* CDN inaccessible — dégradé CSS */ });
  } catch (e) { /* import() non supporté */ }


  /* ─── 2. SCROLL REVEALS — ressort ascendant (remplace CSS .reveal) ─ */
  function initScrollReveals(animate, stagger) {
    var els = document.querySelectorAll('.reveal');
    if (!els.length || !('IntersectionObserver' in window)) return;

    /* Pré-cacher via transform plutôt qu'opacité seule */
    els.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(22px)';
      el.style.willChange = 'transform, opacity';
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);

        /* Délai natif depuis la classe Shopify (reveal-delay-1, -2…) */
        var cls = entry.target.className || '';
        var delayMap = { 'reveal-delay-1': 0.1, 'reveal-delay-2': 0.2, 'reveal-delay-3': 0.3 };
        var delay = 0;
        Object.keys(delayMap).forEach(function (k) { if (cls.indexOf(k) !== -1) delay = delayMap[k]; });

        animate(entry.target,
          { opacity: [0, 1], y: [22, 0] },
          {
            duration: 0.65,
            delay: delay,
            ease: [0.22, 1, 0.36, 1]    /* ease-out — entrée naturelle */
          }
        ).finished.then(function () {
          entry.target.style.willChange = '';
          entry.target.style.transform = '';
        });
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -32px 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ─── 3. CARDS PRODUIT — hover élévation + légère inclinaison ────── */
  function initCardHover(animate) {
    document.querySelectorAll('.product-card').forEach(function (card) {
      card.addEventListener('mouseenter', function () {
        animate(card, { y: -5, scale: 1.015 },
          { duration: 0.3, ease: [0.22, 1, 0.36, 1] });
      });
      card.addEventListener('mouseleave', function () {
        animate(card, { y: 0, scale: 1 },
          { duration: 0.22, ease: [0.55, 0, 1, 0.45] }); /* ease-in sortie */
      });
    });
  }

  /* ─── 4. BOUTONS — scale-feedback au press (§7 scale-feedback) ───── */
  function initButtonPress(animate) {
    document.querySelectorAll('.btn, .bbc-wish-btn').forEach(function (btn) {
      btn.addEventListener('pointerdown', function () {
        animate(btn, { scale: 0.96 }, { duration: 0.1, ease: 'easeIn' });
      });
      btn.addEventListener('pointerup', function () {
        animate(btn, { scale: 1 }, { duration: 0.2, ease: [0.22, 1, 0.36, 1] });
      });
      btn.addEventListener('pointerleave', function () {
        animate(btn, { scale: 1 }, { duration: 0.15 });
      });
    });
  }

  /* ─── 5. TRANSPARENCE — barres + montée compteur (stagger 35ms) ──── */
  function initTransparencyBars(animate, stagger) {
    var rows = document.querySelectorAll('[data-pct]');
    if (!rows.length) return;

    /* Déjà géré par le script inline de la section.
       Motion améliore l'éasing des barres. */
    rows.forEach(function (row) {
      var bar = row.querySelector('.bbc-transp__bar i');
      if (!bar) return;
      var pct = parseFloat(row.getAttribute('data-pct')) || 0;
      /* Reset width to 0, then spring to target */
      bar.style.width = '0';
    });

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.disconnect();

        rows.forEach(function (row, i) {
          var bar = row.querySelector('.bbc-transp__bar i');
          var amt = row.querySelector('.bbc-transp__amount');
          var pct = parseFloat(row.getAttribute('data-pct')) || 0;
          var target = parseFloat((amt && amt.getAttribute('data-amount')) || '0');

          if (bar) {
            animate(bar, { width: pct + '%' }, {
              duration: 1.1,
              delay: stagger(0.055)(i, rows.length),
              ease: [0.22, 1, 0.36, 1]
            });
          }

          if (amt) {
            var obj = { v: 0 };
            animate(obj, { v: target }, {
              duration: 1.2,
              delay: (stagger(0.055)(i, rows.length)),
              ease: [0.22, 1, 0.36, 1],
              onUpdate: function () {
                amt.textContent = obj.v.toFixed(2).replace('.', ',') + ' €';
              }
            });
          }
        });
      });
    }, { threshold: 0.3 });
    var container = document.querySelector('[data-transp-rows]');
    if (container) io.observe(container);
  }

  /* ─── 6. TÉMOIGNAGES — stagger 40ms à l'entrée ─────────────────── */
  function initTestimonialsStagger(animate, stagger) {
    var items = document.querySelectorAll('.bbc-testi__item');
    if (!items.length || !('IntersectionObserver' in window)) return;

    items.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(18px)';
    });

    var io = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      io.disconnect();
      animate(Array.from(items),
        { opacity: [0, 1], y: [18, 0] },
        {
          duration: 0.6,
          delay: stagger(0.04),
          ease: [0.22, 1, 0.36, 1]
        }
      );
    }, { threshold: 0.15 });
    io.observe(items[0]);
  }

})();
